import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_staff/business-partner/_list/overview/')({});